import { render, staticRenderFns } from "./POIViewData.vue?vue&type=template&id=0eb8d08f&"
import script from "./POIViewData.vue?vue&type=script&lang=js&"
export * from "./POIViewData.vue?vue&type=script&lang=js&"
import style0 from "./POIViewData.vue?vue&type=style&index=0&id=0eb8d08f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports